import { Link } from 'react-router-dom';

const PageNotFound = () => {
  return (
    <div className="min-h-[80vh] bg-gray-50 flex flex-col items-center justify-center px-4 font-display">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 rounded-3xl mb-6">
          <span
            className="material-symbols-outlined text-primary text-4xl"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            search_off
          </span>
        </div>

        <p className="text-8xl font-black text-primary tracking-tighter mb-2">404</p>

        <h1 className="text-2xl font-bold text-slate-900 mb-3">Page not found</h1>

        <p className="text-slate-500 max-w-sm mx-auto mb-8">
          We couldn't find the page you were looking for. It may have been moved or deleted.
        </p>

        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary text-white font-semibold px-5 py-2.5 rounded-xl hover:bg-primary-deep transition-colors"
          >
            <span className="material-symbols-outlined text-[18px]">home</span>
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;